module.exports = __webpack_public_path__ + "img/IMG_3945_L_BlackMatted.fb33ea1a.jpg";